import React, { useState } from 'react';
import './SuperAdminLogin.css';
import TextInput from '../../components/TextInput/TextInput';
import {useTranslation} from "react-i18next";
import CustomButton from '../../components/CustomButton/CustomButton';
import { loginSuperAdminAction } from '../../redux/actions/authActions';

function SuperAdminLogin() {

  const {t} = useTranslation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const onSubmit = () => {
    loginSuperAdminAction(username, password);
  }

  const isDisabled = !username || !password;

  return (
    <div className="superAdminLogin">
      <img src={"logoBig.png"} className="loginScreenLogo" alt="logo" />
      <TextInput value={username} onChange={setUsername} label={t("common.username")}/>
      <TextInput value={password} onChange={setPassword} label={t("login.password")} type="password" onEnter={onSubmit}/>
      <CustomButton label={t("login.submit")} onClick={onSubmit} isDisabled={isDisabled} style={{marginBottom: "20px"}}/>
    </div>
  );
}

export default SuperAdminLogin;
